import { createContext, useContext } from 'react';

type HighlightContextData = {
    dataCy?: string;
};

const context = createContext<HighlightContextData>({});

export const HighlightContext = context.Provider;
export const useHighlightContext = (): HighlightContextData => useContext(context);
